module.exports = __webpack_public_path__ + "static/media/timelapse.60b23bd5.md";


//////////////////
// WEBPACK FOOTER
// ./src/markdown/timelapse.md
// module id = 336
// module chunks = 0